module.exports = __webpack_public_path__ + "static/media/slide.75ef3f64.png";